/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useRef as r}from"react";import{useIsoMorphicEffect as e}from"./use-iso-morphic-effect.js";function t(){let t=r(!1);return e((()=>(t.current=!0,()=>{t.current=!1})),[]),t}export{t as useIsMounted};
//# sourceMappingURL=use-is-mounted.js.map
